import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import ReactDOM from 'react-dom'
import { HashRouter } from 'react-router-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import store from './store'
// Auth0ProviderWithHistory is only rendered in non-Zitadel mode
import Auth0ProviderWithHistory from './components/auth/Auth0ProviderWithHistory'
import ZitadelProviderWithHistory from './components/auth/ZitadelProviderWithHistory'
import { createBrowserHistory } from 'history'

// Auth0 config — only used when REACT_APP_AUTH_PROVIDER !== 'zitadel'
// const domain = 'dev-w2nvmnzr.eu.auth0.com'
const domain = 'login.routines.world'
const clientId = '0Hx6RgMkoZATGfhcgP1ljTJ7E7rvSrhG'
const audience = 'http://localhost:8080/'
const history = createBrowserHistory()

const isZitadel = process.env.REACT_APP_AUTH_PROVIDER === 'zitadel'

// ReactDOM.render(
//   <Auth0Provider
//     domain={domain}
//     clientId={clientId}
//     redirectUri={window.location.origin}
//     audience={audience}
//   >
//     <Provider store={store}>
//       <Router>
//         <Auth0Wrapper>
//           <App />
//         </Auth0Wrapper>
//       </Router>
//     </Provider>
//   </Auth0Provider>,
//   document.getElementById('root'),
// )

// Conditionally render Zitadel or Auth0 provider — never both
const AuthProvider = isZitadel ? ZitadelProviderWithHistory : Auth0ProviderWithHistory

ReactDOM.render(
  <Provider store={store}>
    <HashRouter history={history}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </HashRouter>
  </Provider>,
  document.getElementById('root'),
)

serviceWorker.register()
